import React from "react";

export const DesktopIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden>
    <rect
      x="3"
      y="4"
      width="18"
      height="12"
      rx="2"
      stroke="currentColor"
      fill="none"
      strokeWidth="2"
    />
    <path
      d="M8 20h8M10 16v4M14 16v4"
      stroke="currentColor"
      fill="none"
      strokeWidth="2"
    />
  </svg>
);

export const ServerIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden>
    <rect
      x="3"
      y="4"
      width="18"
      height="6"
      rx="2"
      stroke="currentColor"
      fill="none"
      strokeWidth="2"
    />
    <rect
      x="3"
      y="14"
      width="18"
      height="6"
      rx="2"
      stroke="currentColor"
      fill="none"
      strokeWidth="2"
    />
    <circle cx="8" cy="7" r="1" fill="currentColor" />
    <circle cx="8" cy="17" r="1" fill="currentColor" />
  </svg>
);

export const UsersIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden>
    <circle
      cx="9"
      cy="8"
      r="3"
      stroke="currentColor"
      fill="none"
      strokeWidth="2"
    />
    <path
      d="M3 20c0-3.314 2.686-6 6-6"
      stroke="currentColor"
      fill="none"
      strokeWidth="2"
    />
    <circle
      cx="17"
      cy="10"
      r="2.5"
      stroke="currentColor"
      fill="none"
      strokeWidth="2"
    />
    <path
      d="M13 20c0-2.5 2-4.5 4.5-4.5"
      stroke="currentColor"
      fill="none"
      strokeWidth="2"
    />
  </svg>
);

export const PlugIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden>
    <path
      d="M8 7v4M16 7v4M6 11h12"
      stroke="currentColor"
      fill="none"
      strokeWidth="2"
    />
    <path
      d="M12 11v6a3 3 0 0 1-3 3h6a3 3 0 0 1-3-3"
      stroke="currentColor"
      fill="none"
      strokeWidth="2"
    />
  </svg>
);

export const CloudIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden>
    <path
      d="M4 15a4 4 0 010-8 5 5 0 019.9-1A4.5 4.5 0 0118 15H4z"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);

export const CpuNetworkIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden>
    <rect
      x="4"
      y="4"
      width="16"
      height="16"
      rx="2"
      stroke="currentColor"
      fill="none"
      strokeWidth="2"
    />
    <path
      d="M9 9h6v6H9zM2 9h2M2 15h2M20 9h2M20 15h2M9 2v2M15 2v2M9 20v2M15 20v2"
      stroke="currentColor"
      fill="none"
      strokeWidth="2"
    />
  </svg>
);
